export const sanitizeInput = (input: string): string => {
  return input
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/javascript:/gi, '')
    .replace(/data:/gi, '')
    .replace(/vbscript:/gi, '');
};

export const sanitizeAndTrimInput = (input: string): string => {
  return sanitizeInput(input)
    .replace(/\s+/g, ' ') // Replace multiple spaces with single space
    .trim();
};

export const validateTextLength = (text: string, maxLength: number): boolean => {
  return text.length <= maxLength && text.length > 0;
};
